/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Line, ComposedChart,
} from 'recharts';
import CardPanel from '../../../../../shared/components/widgets/CardPanel';
import style from '../../../../../shared/components/themeSupport';
import {
  formatDecimalToFixedTwoPercent, formatNumberWhole,
} from '../../../../../shared/components/table/functions';

export default function GlancesVsSalesPercentage({ loading, data }) {
  const theme = useSelector(state => state.theme);

  return (
    <CardPanel
      md={12}
      title="Glance Views VS PPC Sales %"
      parentRefresh={loading}
    >
      {!loading && data && (
        <ResponsiveContainer height={250} className="dashboard__area">
          <ComposedChart data={data}>
            <CartesianGrid stroke={style(theme).colorText} />
            <XAxis dataKey="rankDate" stroke={style(theme).colorText} />
            <YAxis
              yAxisId="ppcpercentage"
              orientation="right"
              stroke={style(theme).colorText}
              tickFormatter={val => formatDecimalToFixedTwoPercent({ value: val })}
            />
            <YAxis
              yAxisId="glance"
              stroke={style(theme).colorText}
              tickFormatter={val => formatNumberWhole(val)}
            />
            <Tooltip />
            <Legend />
            <Line
              name="Glance Views"
              type="monotone"
              dataKey="glance_views"
              yAxisId="glance"
              stroke={style(theme).lineGray}
              strokeWidth={2}
              formatter={val => formatNumberWhole(val)}
            />
            <Line
              name="PPC Sales %"
              type="monotone"
              dataKey="ppc_sales_percent"
              yAxisId="ppcpercentage"
              stroke={style(theme).lineOrange}
              strokeWidth={2}
              formatter={val => formatDecimalToFixedTwoPercent({ value: val })}
            />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </CardPanel>
  );
}

GlancesVsSalesPercentage.defaultProps = {
  data: null,
};

GlancesVsSalesPercentage.propTypes = {
  loading: PropTypes.bool.isRequired,
  data: PropTypes.instanceOf(Array),
};
